import React from "react";
import { Modal } from "react-bootstrap";
import SuccessIconPic from "../../../../assets/images/success-icon.png";
import useLangTranslation from "../../../customHooks/languageProvider";

export const SendSoundAlert = ({ showModal, closeModal, kidData }) => {
  const { getLangTranslation } = useLangTranslation();
  return (
    <Modal show={showModal} size="sm" className="custom-modal blur-bg" centered>
      <Modal.Header>
      <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">{getLangTranslation("DEVICE_SEND_SOUND_ALERT", "Send sound alert")}</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
      </Modal.Header>
      <Modal.Body className="py-1 px-4">
        <div className="modal-body">
          <h6 className="my-6 text-center text-blue-900">
            {getLangTranslation("DEVICE_DETAIL_FIND_DEVICE_TITLE", "Send sound alert to")} {kidData?.kidName}'s {getLangTranslation("CONNECT_DEVICE_TITLE_2", "device")}{" "}
            {kidData?.deviceName}
          </h6>
          <img className="d-block mx-auto mb-6" src={SuccessIconPic} alt="" />
          <h5 className="text-blue-600 text-center mb-9">
            {getLangTranslation("DEVICE_DETAIL_FIND_DEVICE_SUCCESS", "A sound alert was successfully sent")}
          </h5>
          <button
            className="btn btn-primary w-100"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={closeModal}
          >
            <span className="btn-upper-case">{getLangTranslation("ADD_PARENT_GOT_IT", "Got It")}</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
